import { Component } from '@angular/core';
import { JurisdictionObligationOption } from '../../models/master-data/jurisdiction-obligation-option.model';
import { ApiCallCachingService } from '../../services/api-call-caching.service';
import { JurisdictionObligationOptionService } from '../../services/jurisdiction-obligation-option.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';


@Component({
  selector: 'spv2-jurisdiction-obligation-options-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class JurisdictionObligationOptionsDropdownComponent extends DropdownBaseComponent<string, JurisdictionObligationOption> {

  uniqueName = "jurisdictionObligationOptions"

  textField = "name";
  valueField = "code";

  enableCache = false;

  dataFunction = (filter: string) => this.jurisdictionObligationOptionService.getJurisdictionObligationOptions(filter);

  constructor(private jurisdictionObligationOptionService: JurisdictionObligationOptionService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
